__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "courses-spa-app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(914), __webpack_require__.e(158)]).then(() => (() => (__webpack_require__(54158))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(914), __webpack_require__.e(985), __webpack_require__.e(479)]).then(() => (() => (__webpack_require__(71479))))));
			register("@mui/material", "6.5.0", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(786), __webpack_require__.e(203), __webpack_require__.e(879), __webpack_require__.e(225), __webpack_require__.e(590), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(985), __webpack_require__.e(646)]).then(() => (() => (__webpack_require__(98590))))));
			register("pvs-design-icons", "1.7.0", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(786), __webpack_require__.e(879), __webpack_require__.e(30), __webpack_require__.e(914), __webpack_require__.e(985), __webpack_require__.e(646), __webpack_require__.e(185)]).then(() => (() => (__webpack_require__(3030))))));
			register("pvs-design-system", "4.10.1", () => (Promise.all([__webpack_require__.e(923), __webpack_require__.e(786), __webpack_require__.e(203), __webpack_require__.e(225), __webpack_require__.e(845), __webpack_require__.e(32), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(985), __webpack_require__.e(646), __webpack_require__.e(204), __webpack_require__.e(817)]).then(() => (() => (__webpack_require__(4032))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(733), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(971)]).then(() => (() => (__webpack_require__(69733))))));
			register("react-router-dom", "7.18.2", () => (Promise.all([__webpack_require__.e(886), __webpack_require__.e(914), __webpack_require__.e(672)]).then(() => (() => (__webpack_require__(2886))))));
			register("react", "18.3.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};